import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import {
  type PortalTabbedNavigationTab,
  TabbedNavigationGroup,
} from '../../../../../../../../../../../../../components/router/router-tabbed-navigation';
import { CostBasisRealizationsTable } from '../../../../../../../../../../../../../features/cost-basis/realization/cost-basis-realizations-table';
import { AccountPortfolioAssetBalanceHeader } from '../../../../../../../../../../../../../features/registration/account/account-portfolio-asset-balance-header';

export const Route = createFileRoute(
  '/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset/$assetId/_asset-balance/realization/',
)({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.RegistrationAccountPortfolioAssetBalance,
      label: 'Realizations',
      order: 4,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.RegistrationAccountPortfolioAssetBalance>,
  component: AccountAssetRealizationList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  const { accountId, assetId } = Route.useParams();
  return <AccountPortfolioAssetBalanceHeader accountId={accountId} assetId={assetId} filter={filter} />;
}

function AccountAssetRealizationList() {
  const { accountId, assetId } = Route.useParams();

  return (
    <PageLayout.Section noBorder>
      <CostBasisRealizationsTable accountId={accountId} assetId={assetId} HeaderActions={TableHeader} />
    </PageLayout.Section>
  );
}
